// extracted by css-extract-rspack-plugin
export default {"queryButton":"WmZJM IXEGd _Uhde","queryButtonText":"EAGc_ SJXBn"};